import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c5e519b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#B5B5C3 !important","font-weight":"500 !important","font-size":"1.15rem !important"}
}
const _hoisted_2 = {
  key: 1,
  style: {"color":"#B5B5C3 !important","font-weight":"500 !important","font-size":"1.15rem !important"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_6 = { class: "accordion-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-4 fw-bold",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_1",
    "aria-expanded": "true",
    "aria-controls": "kt_accordion_1_body_1"
  }, " Areas of Expertise Sought ")
], -1))
const _hoisted_8 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["data-id"]
const _hoisted_12 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_13 = { class: "accordion-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-4 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_2",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_2"
  }, " Select Industry Sector(s) ")
], -1))
const _hoisted_15 = {
  id: "kt_accordion_1_body_2",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_2",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_16 = { class: "accordion-body" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = ["data-id"]
const _hoisted_19 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_20 = {
  key: 0,
  style: {"color":"red","padding":"8px 20px"}
}
const _hoisted_21 = { class: "row my-3 gx-5 gy-md-3 gy-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpertDetailsCard = _resolveComponent("ExpertDetailsCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    true
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Please select a minimum of 3 expert profiles to address any gaps/challenges that the business is currently facing. The aim is to provide access to a breadth of industry expertise via this step of expert curation. "))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " You must complete this step to create your profile. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertise, (e) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: e.id,
                      class: "form-check form-check-custom form-check-solid my-3 col-md-3"
                    }, [
                      _createElementVNode("input", {
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToExpertise($event))),
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexCheckDefault",
                        "data-id": e.id
                      }, null, 40, _hoisted_11),
                      _createElementVNode("label", _hoisted_12, _toDisplayString(e.name), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industrySectors, (is) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: is.id,
                      class: "form-check form-check-custom form-check-solid my-3 col-md-3"
                    }, [
                      _createElementVNode("input", {
                        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToIndustrySectors($event))),
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault",
                        "data-id": is.id
                      }, null, 40, _hoisted_18),
                      _createElementVNode("label", _hoisted_19, _toDisplayString(is.name), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        (_ctx.showError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Select Atleast one " + _toDisplayString(_ctx.selectedExpertise.length
              ? _ctx.selectedIndustrySectors.length
                ? ""
                : "Industry Sector"
              : "Expertise") + " to Find Experts ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredExperts, (expert) => {
        return (_openBlock(), _createElementBlock("div", {
          key: expert.id,
          class: "col-12"
        }, [
          (_openBlock(), _createBlock(_component_ExpertDetailsCard, {
            selectedExpertise: _ctx.selectedExpertise,
            key: expert.id,
            name: expert.name,
            jobTitle: expert.jobTitle,
            profilePicture: expert?.user?.profileImage ?? '',
            linkedInProfile: expert.linkedInProfileUrl,
            introduction: expert.introduction,
            online: true,
            expertId: expert.id,
            avatar: "media/avatars/blank.png",
            connected: false,
            "avg-earnings": "$14,560",
            "total-sales": "$236,400",
            isAlreadyConnected: _ctx.isAlreadyConnected(expert.id),
            expertRequisiteConnectionStatus: _ctx.expertRequisiteConnectionStatus,
            founderRequisiteExpertsMain: _ctx.founderRequisiteExperts
          }, null, 8, ["selectedExpertise", "name", "jobTitle", "profilePicture", "linkedInProfile", "introduction", "expertId", "isAlreadyConnected", "expertRequisiteConnectionStatus", "founderRequisiteExpertsMain"]))
        ]))
      }), 128))
    ])
  ]))
}